/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_content_delivery_bucket": "crowdify-20200602175206-hostingbucket-production",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "http://crowdify-20200602175206-hostingbucket-production.s3-website.eu-central-1.amazonaws.com",
    "aws_cognito_identity_pool_id": "eu-central-1:6555a344-fea0-4b44-b338-55ba2938b9a1",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_qevAnPeXV",
    "aws_user_pools_web_client_id": "32omu7l1goja5r69pfq43llstb",
    "oauth": {}
};


export default awsmobile;
